/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Birthday/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Birthday({
  children,
  viewPath = "/DesignSystem/PersonMatches/Content/PersonMatch/Details/Content/Person/Birthday"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let personMatchBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'person_match',
path: 'birth_date',
format: fromFormat.dateISOIn,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Birthday.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1kT6dW': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Date of Birth"
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="person_match.birth_date"
 format="/Data/format.js dateISOIn"
 text={personMatchBirthDateValueData}
/>
</div>
{children}
</React.Fragment>)
}